import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from './auth.service';
import { AuthInactivityService } from '../services/auth-inactivity.service';
import { SharedService } from '../shared_service';
import { DomainConfigComponent } from '../domain-config.component';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { Credentials } from '../models/credentials';
import { RecoverPasswordDialogComponent } from './../dialogs/recover-password-dialog/recover-password-dialog.component';
import { NgxPermissionsService } from 'ngx-permissions';
import { setUsetifulTags } from 'usetiful-sdk';
import { UserServiceApi } from '../services/services/user.service';
import { getUserInfo } from '../util/auth/helpers';
import { environment } from '../../environments/environment';
import { MicrosoftOAuthService } from '../services/microsoft-oauth.service';
import { GoogleOAuthService } from '../services/google-oauth.service';
import { brand } from '@app/branding/brand';
import { hasForcePasswordChangeFlag } from '../util/auth/helpers';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {
	credentials: Credentials;
  showPassword = false;
  errorMessage: string;
  readonly brandName = brand.name;
  returnUrl: string;
	domain = null;
	config = {};
  changeAddress: any;

  constructor(
		private _auth: AuthService,
		private _authInactivity: AuthInactivityService,
		private _route: ActivatedRoute,
    	private _sharedService: SharedService,
		private _domainConfigComponent: DomainConfigComponent,
		private permissionsService: NgxPermissionsService,
		private sanitizer: DomSanitizer,
		private modalService: NgbModal,
		private userService: UserServiceApi,
		private microsoftOAuth: MicrosoftOAuthService,
		private googleOAuth: GoogleOAuthService,
		private router: Router)
	{
		this.credentials = new Credentials('', '');
		_domainConfigComponent.load().then(() => {
			this.domain = _domainConfigComponent.id || null;
			this.config = _domainConfigComponent.Config || {};
			this.changeAddress = this.sanitizer.bypassSecurityTrustHtml(_domainConfigComponent.getConfigFlag(['login', 'address']));
		});
	}

  ngOnInit() {
	}

  async loginWithGoogle() {
    try {
      const result = await this.googleOAuth.openAuthPopup();
      const data = await this._auth.oauthLogin('google', result.provider_id, result.email);
      if (data['result'] === false) {
        this.errorMessage = 'No hay cuenta vinculada con este Google. Inicia sesión con tu contraseña.';
        return;
      }
      await this.postLoginFlow();
    } catch (error) {
      this.errorMessage = 'Error al iniciar sesión con Google';
    }
  }

  async loginWithMicrosoft() {
    try {
      const result = await this.microsoftOAuth.openAuthPopup();
      const data = await this._auth.oauthLogin('microsoft', result.provider_id, result.email);
      if (data['result'] === false) {
        this.errorMessage = 'No hay cuenta vinculada con este Microsoft. Inicia sesión con tu contraseña.';
        return;
      }
      await this.postLoginFlow();
    } catch (error) {
      this.errorMessage = 'Error al iniciar sesión con Microsoft';
    }
  }

  private async postLoginFlow() {
    const resp = await this._auth.getListPermissions();
    if (resp['result']) {
      localStorage.setItem("USER_PERMISSIONS", JSON.stringify(resp['result']));
      this.permissionsService.loadPermissions(resp['result']);

      const userInfo = getUserInfo();
      await this.userService.getUser(userInfo.data.id).then((response) => {
        setUsetifulTags({
          userId: response['result'].id,
          firstName: response['result'].name,
          lastName: response['result'].email,
        });
      });
    }
    this.loginValidRedirect();
  }

	async onLogin( form: NgForm) {
	    const loginResult = await this.login(form);
		if (loginResult) {
			this.loginValidRedirect();
		}
	}

	async login(form: NgForm): Promise<boolean>{
		if(form.valid) {
			try {
				const data = await this._authInactivity.login(this.credentials);
				if (data['result'] === false) {
					this.errorMessage = 'Email o contraseña incorrecta';
					return false;
				} else {
					const resp= await this._auth.getListPermissions();
					if(resp['result']){
						localStorage.setItem("USER_PERMISSIONS",JSON.stringify(resp['result']));
						this.permissionsService.loadPermissions(resp['result']);

						const userInfo = getUserInfo();

						await this.userService.getUser(userInfo.data.id).then((response) => {
							setUsetifulTags({
								userId: response['result'].id,
								firstName: response['result'].name,
								lastName: response['result'].email,
							  });
						});
					}
					this.credentials = new Credentials('', '');
					form.reset();
					return true;
				}
			} catch (error) {
				console.error('Login error:', error);
				this.errorMessage = 'Error de conexión';
				return false;
			}
		}
		return false;
	}

	loginValidRedirect(){
		this._domainConfigComponent.load().then(() => {
			if (hasForcePasswordChangeFlag()) {
				this.router.navigate(['/change-password']);
				return;
			}
			this._sharedService.emitLogin('home');
		});
	}

	changePassword(): void {
		const modalRef = this.modalService.open(RecoverPasswordDialogComponent, {
			centered: true,
			size: 'md',
		});
		modalRef.result.then(() => {}).catch(() => {});
	}
	getValidationMessages(state: any, thingName?: string){
		let thing: string = state.path || thingName;
		let messages: string [] = [];
		if (state.errors) {
			for(let errorName in state.errors) {
				switch(errorName){
					case 'required':
						messages.push(`Introduzca un ${thing}`);
						break;
					case "pattern":
						messages.push(`Introduzca un ${thing} válido`);
						break;
				}
			}
		}
		return messages;
	}
}
